import script from "./ChartTemplateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTemplateForm.vue?vue&type=script&setup=true&lang=js"

import "./ChartTemplateForm.vue?vue&type=style&index=0&id=57a6c32e&lang=scss"

const __exports__ = script;

export default __exports__